import { render } from "./StudentHome.vue?vue&type=template&id=50ba0ebf&scoped=true"
import script from "./StudentHome.vue?vue&type=script&lang=js"
export * from "./StudentHome.vue?vue&type=script&lang=js"

import "./StudentHome.vue?vue&type=style&index=0&id=50ba0ebf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ba0ebf"]])

export default __exports__